<div class="container-fluid psp-container">
    <div class="card mb-4 attachment-card">
        <div class="modal-header">
            <h4 class="modal-title">Attachment Preview</h4>
            <button type="button" class="close" aria-label="Close" (click)="closeModal()">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <div class="modal-body text-center"> <!-- Center the content -->
            <div *ngIf="isImage(rxAttachmentUrl)" class="attachment-content">
                <img [src]="rxAttachmentSafeUrl" alt="Attachment">
            </div>
            <div *ngIf="isPdf(rxAttachmentUrl)" class="attachment-content" >
                <iframe [src]="rxAttachmentSafeUrl" frameborder="0" width="100%" height="500" type="application/pdf"></iframe>
            </div>
        </div>
        <div class="modal-footer">
            <button class="btn btn-neutral" [disabled]="!rxAttachmentUrl" (click)="downloadRxFile()">
                <span class="btn-inner--icon">
                    <i class="fas fa-file-download"></i>
                </span>
                <span class="btn-inner--text"> Download Rx Attachment </span>
            </button>
        </div>
    </div>
</div>
